import { useEffect, useState } from "react";
import HomeNav from "../nav/HomeNav";
import GorillianCanvas from "../util/GorillianCanvas";

export const HOME_LOGO_SCALE = 0.95;

let homeIntroSeen = false;

function shouldSkipIntro() {
  if (homeIntroSeen) return true;
  if (typeof window === "undefined") return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

export default function Home() {
  const skipped = shouldSkipIntro();
  const [armed, setArmed] = useState(skipped);
  const [entered, setEntered] = useState(skipped);
  const [progress, setProgress] = useState(skipped ? 1 : 0);

  useEffect(() => {
    if (!armed || entered) return undefined;

    const audio = new Audio("/static-noise.mp3");
    audio.volume = 0.4;
    const start = () => {
      audio.currentTime = 0.84;
      audio.play().catch(() => {});
    };
    if (audio.readyState >= 1) start();
    else audio.addEventListener("loadedmetadata", start, { once: true });

    return () => {
      audio.pause();
      audio.src = "";
    };
    // Only start on the click; don't stop the clip when the reveal finishes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [armed]);

  useEffect(() => {
    if (!armed || entered) return undefined;

    const started = performance.now();
    const duration = 2100;
    let frameId;

    const tick = (now) => {
      const t = Math.min(1, (now - started) / duration);
      const eased = 1 - Math.pow(1 - t, 3);
      setProgress(eased);
      if (t < 1) {
        frameId = requestAnimationFrame(tick);
        return;
      }
      homeIntroSeen = true;
      setEntered(true);
    };

    frameId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frameId);
  }, [armed, entered]);

  return (
    <div className="home-header-container">
      <GorillianCanvas
        intensity={0.85}
        progress={progress}
        logoScale={HOME_LOGO_SCALE}
      />
      {!armed && (
        <button
          type="button"
          className="gorillian-load"
          onClick={() => setArmed(true)}
        >
          <span>Welcome, click to enter</span>
        </button>
      )}
      <HomeNav active={entered} logoScale={HOME_LOGO_SCALE} />
    </div>
  );
}
